import { useEffect } from "react";
import { useAgentStore } from "@/stores/agentStore";

/**
 * Ctrl J (⌘ J sur Mac) ouvre l'agent de n'importe quel écran. J et non K :
 * Ctrl K est déjà la palette de création.
 */
export function useAgentShortcut(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "j") {
        e.preventDefault();
        useAgentStore.getState().setOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [enabled]);
}
